import { motion } from 'framer-motion';
import { getUploadUrl } from '../utils/api';

const WhyChooseUs = () => {
  const values = [
    {
      title: 'Premium Quality',
      description: 'We source only the finest faux flowers and materials to ensure our arrangements look stunningly realistic.',
      image: '/images/premium-quality.jpg'
    },
    {
      title: 'Professional Service',
      description: 'Our experienced team provides expert styling advice and ensures flawless setup for your special occasion.',
      image: '/images/professional-service.jpg'
    },
    {
      title: 'Attention to Detail',
      description: 'Every arrangement is crafted with meticulous care, ensuring perfection in every petal and detail.',
      image: '/images/attention-to-detail.jpg'
    },
    {
      title: 'Flexible Solutions',
      description: 'We offer customizable packages and rental periods to suit your specific needs and budget.',
      image: '/images/flexible-solutions.jpg'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Values Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="text-center mb-12 pt-[50px]">
            <h2 className="text-5xl font-bold text-neutral-800 mb-4">Why We're Different</h2>
            <div className="text-lg text-neutral-600 max-w-4xl mx-auto pb-[50px] space-y-4">
              <p>We love what we do. We are passionate about transforming events into beautifully aesthetic and luxurious experiences.</p>
              <p>Our team brings extensive experience across the event industry, led by our lead f loral designer with over a decade of expertise in floral styling and professional training in fresh floral artistry.</p>
              <p>We love listening to your creative ideas. bringing our cilent's visual and art to life is part of our passion and the backbone of our business.</p>
              <p>We offer all-in-one experience by providing a wide range of styling elements, helping to simplify the planning process and reduce the need for multiple vendors.</p>
              <p>We provide budget flexible packages that are thoughtfully curated to suit a variety of event design , ensuring beautiful results without compromise.</p>
            </div>
          </div>

          <div className="space-y-16">
            {values.map((value, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
                viewport={{ once: true }}
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                  {index % 2 === 0 ? (
                    <>
                      <div className="relative">
                        <img
                          src={value.image}
                          alt={value.title}
                          className="w-full aspect-square object-cover rounded-2xl"
                        />
                      </div>
                      <div>
                        <h2 className="text-5xl font-semibold text-neutral-800 mb-4">
                          {value.title}
                        </h2>
                        <p className="text-lg text-neutral-600">
                          {value.description}
                        </p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <h2 className="text-5xl font-semibold text-neutral-800 mb-4">
                          {value.title}
                        </h2>
                        <p className="text-lg text-neutral-600">
                          {value.description}
                        </p>
                      </div>
                      <div className="relative">
                        <img
                          src={value.image}
                          alt={value.title}
                          className="w-full aspect-square object-cover rounded-2xl"
                        />
                      </div>
                    </>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyChooseUs;